import { render, staticRenderFns } from "./SignLanguageModal.vue?vue&type=template&id=6000a3d0&"
import script from "./SignLanguageModal.vue?vue&type=script&lang=js&"
export * from "./SignLanguageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports